import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { v4 as uuid } from "uuid";
import Link from "@mui/material/Link";
import { useSelector, useDispatch } from "react-redux";
import { goToPage } from "../redux/pageSlice";

function groupConsecutivePages(pages) {
  const groupedPages = [];
  let start = pages[0];
  let end = start;

  for (let i = 1; i < pages.length; i++) {
    if (pages[i] - end === 1) {
      end = pages[i];
    } else {
      groupedPages.push(start === end ? start : `${start}-${end}`);
      start = end = pages[i];
    }
  }

  groupedPages.push(start === end ? start : `${start}-${end}`);
  return groupedPages;
}

function extractMedications(data) {
  const meds = data[data.length - 2];
  var returnArr = [];
  for (var name in meds) {
    const info = meds[name]["data"][0]["information"];
    const pages = meds[name]["data"][0]["pages"].map((page) => page);

    const id = uuid();
    returnArr.push({ name, info, pages, id });
  }
  return returnArr;
}

export default function Medications({ data }) {
  const rows = extractMedications(data);
  const dispatch = useDispatch();

  const handleClick = (value) => () => {
    console.log(value);
    dispatch(goToPage(value));
  };

  if (rows.length === 0) {
    return (
      <>
        <p align="center">No medications could be extracted; see PDF for more.</p>
      </>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ width: "100%", maxWidth: "100%", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)" }}>
      <Table sx={{ width: "100%", maxWidth: "100%" }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell align="left" style={{ width: "175px", maxWidth: "175px" }}>Medication</TableCell>
            <TableCell align="left" style={{ width: "50%", maxWidth: "50%" }}>Information</TableCell>
            <TableCell align="left" style={{ width: "20%", maxWidth: "20%" }}>Pages</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row" style={{ width: "175px", maxWidth: "175px", overflowWrap: "break-word" }}>
                <div style={{ maxWidth: "80%" }}>{row.name}</div>
              </TableCell>
              <TableCell align="left" style={{ width: "50%", maxWidth: "50%", overflowWrap: "break-word" }}>{row.info}</TableCell>
              <TableCell align="left" style={{ width: "20%", maxWidth: "20%" }}>
                {groupConsecutivePages(row.pages).map((p, index) => (
                  <Link
                    key={index}
                    style={{ cursor: "pointer" }}
                    onClick={handleClick(typeof p === 'string' ? p.split('-')[0] : p)}
                  >
                    {p + " "}
                  </Link>
                ))}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}